let YTIFrameAPIResolver;
const YTIFrameAPILoaded = new Promise(resolve => (YTIFrameAPIResolver = resolve));

let YTIFrameAPILoadStarted = false;
const loadYTIFrameAPI = () => {
  const YTIFrameAPIScript = document.createElement('script');
  YTIFrameAPIScript.src = 'https://www.youtube.com/iframe_api';

  document.body.appendChild(YTIFrameAPIScript);

  window.onYouTubeIframeAPIReady = function () {
    YTIFrameAPIResolver();
    delete window.onYouTubeIframeAPIReady;
  };
};

class FCCUMedia extends HTMLElement {
  classname;
  attributes = {};
  is = null;

  image;
  image_el = document.createElement('img');

  video;
  video_options = {};
  video_player;
  video_el = document.createElement('div');

  aspect = {
    height: null,
    width: null,
  };

  media = '(min-width: 0px)';

  async #playVideo() {
    if (!YTIFrameAPILoadStarted) {
      YTIFrameAPILoadStarted = true;
      loadYTIFrameAPI();
    }

    await YTIFrameAPILoaded;

    const playerVars = {};
    this.video_options.forEach((value, key) => (playerVars[key] = value));

    this.video_player = new YT.Player(this.video_el, {
      videoId: this.video,
      height: this.aspect.height,
      width: this.aspect.width,
      playerVars: {
        playsinline: 1,
        allowfullscreen: 1,
        ...playerVars,
      },
      events: {
        onReady: event => {
          event.target.playVideo();
        },
      },
    });

    this.video_el = this.video_player.getIframe();
    this.#applyAttributes('video');
    this.video_el.style.aspectRatio = `${this.aspect.width} / ${this.aspect.height}`;
    this.appendChild(this.video_el);

    this.is = 'video';
    this.setAttribute('is', this.is);
  }

  #showImage() {
    this.appendChild(this.image_el);
    this.is = 'image';
    this.setAttribute('is', this.is);
  }

  #transform() {
    const isMobile = !this.media.matches;
  
    if (this.video && (!isMobile || !this.image || this.image.trim() === '')) {
      this.#playVideo();
    } else if (isMobile && this.image && this.image.trim().length > 0) {
      this.#showImage();
    }
  }  

  #applyAttributes(el) {
    if (this.classname) {
      this[`${el}_el`].classList.add(`${this.classname}__${el}`);
    }
    Object.entries(this.attributes).forEach(([attr, value]) => {
      this[`${el}_el`].setAttribute(attr, value);
    });
  }

  #handleChildren() {
    if (typeof this.image === 'string' && this.image.trim().length > 0) {
      this.#applyAttributes('image');
      this.image_el.onload = () => {
        this.aspect.height = this.image_el.height;
        this.aspect.width = this.image_el.width;
      };
      this.image_el.src = this.image;
    }

    requestAnimationFrame(this.#transform.bind(this));
  }

  #parseVideo() {
    try {
      const { search } = new URL(this.video);
      this.video_options = new URLSearchParams(search);

      const regex = /^.*(?:(?:youtu.be\/)|(?:v\/)|(?:\/u\/\w\/)|(?:embed\/)|(?:watch\?))\??v?=?([^#&?]*).*/;
      const match = this.video.match(regex);
      this.video = match && match[1].length === 11 ? match[1] : false;
    } catch {
      this.video = false;
    }
  }

  #applySettings() {
    this.classname = this.getAttribute('class');

    this.getAttributeNames().forEach(name => {
      if (Object.hasOwn(this, name)) {
        let value = this.getAttribute(name);
        if (value === 'true') value = true;
        if (value === 'false') value = false;

        this[name] = value;
        this.removeAttribute(name);
      } else if (!['class', 'id'].includes(name)) {
        this.attributes[name] = this.getAttribute(name);
        this.removeAttribute(name);
      }
    });
  
    this.media = window.matchMedia(this.media || '(pointer: fine)');
  }

  connectedCallback() {
    this.#applySettings();
    this.#parseVideo();
    this.#handleChildren();
  }

  constructor() {
    super();
  }
}

window.customElements.define('fccu-media', FCCUMedia);